module["exports"] = [
  "######"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/address/postcode.js
// module id = 1997
// module chunks = 0